import React from 'react';
import { Document, Page } from 'react-pdf';
import { IcertificateDetails } from '../../TypesAndInterfaces';

interface CertificateThumbnailProps {
  certificate: IcertificateDetails;
  isSelected: boolean;
  onClick: () => void;
  pdfUrl: string;
  index: number;
}

const CertificateThumbnail: React.FC<CertificateThumbnailProps> = ({
  certificate,
  isSelected,
  onClick,
  pdfUrl,
  index,
}) => {
  return (
    <button
      key={`cert-thumb-${certificate.certificate.id}-${certificate.certificate._id}`}
      type="button"
      className={`relative border rounded p-2 bg-white h-full ${
        isSelected ? 'border-orange-500' : ''
      }`}
      onClick={onClick}
      aria-label={`Select certificate ${index + 1}`}
    >
      {isSelected && (
        <div className="absolute -top-2 -left-2 w-4 h-4 bg-[#E97862] rounded-full flex items-center justify-center z-10">
          <svg
            width="10"
            height="10"
            viewBox="0 0 10 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M8.5 2.5L3.5 7.5L1.5 5.5"
              stroke="white"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
      )}
      <div className="w-[10%] medium:!w-[120px] h-full pointer-events-none">
        <Document file={pdfUrl} loading="" className="w-[120px]">
          <Page
            pageNumber={1}
            loading=""
            width={120}
            renderTextLayer={false}
            renderAnnotationLayer={false}
          />
        </Document>
      </div>
    </button>
  );
};

export default CertificateThumbnail;
